import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";

export default class ReconnectSocketState extends BaseState {

  begin() {
    Signals.socketOpened.add(this.onSocketOpened, this)
  }

  onSocketOpened(data) {
    this.stateMachine.setState(GameStatesEnum.INIT)
  }

  cleanUp() {
    Signals.socketOpened.remove(this.onSocketOpened, this)
  }

}
